












/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ContentStreamSubscriberDTO } from "../Generated/ParticaAPI";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig } from "../Models/Buttons";
import ParticaAccountBase from "./Base/ParticaAccountBase.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { IContentStreamService } from "../BusinessServices/contentstream";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import { ParticaListContent } from "../Models/ParticaListModel";

@Component(
	{
		name: "ContentSubscriptions",
		components: {
			ParticaCard,
			ParticaView,
			ParticaList2Line
		}
	})
export default class ContentSubscriptions extends ParticaAccountBase {
	@Prop() private id: number;

	private subscriptions: ParticaListContent = new ParticaListContent();
	private contentStreamService: IContentStreamService;
	private buttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS, label: "View Articles" } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS: {
					this.navigate("streamsub", { id: event.item.id });
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Stream Subscriptions";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.contentStreamService = this.particaServices.getContentStreamService();
			this.subscriptions = await this.contentStreamService.getSubscriptionsForAccount(this.id);
			await this.getAccountNav(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}
}
